import { images } from '../shared/assets';
import { FilmCardData } from './FilmCard/FilmCard';

export const filmCards: FilmCardData[] = [
  {
    id: '1',
    title: 'Rewilding Iguazú',
    location: 'AWASI IGUAZÚ',
    videoImage: images.filmImg9, // This is an MP4
    stillImage: images.filmImg11 // Use a still image
  },
  {
    id: '2',
    title: 'A Peculiar Quietness',
    location: 'AWASI ATACAMA',
    videoImage: images.filmImg12, // This is an MP4
    stillImage: images.filmImg11 // This is a PNG
  },
  {
    id: '3',
    title: 'How can you buy or sell the sky?',
    location: 'AWASI FOUNDATION',
    videoImage: images.filmVideo1, // This is an MP4
    stillImage: images.filmImg11 // Use a still image
  },
  {
    id: '4',
    title: 'The Power of Art',
    location: 'AWASI IGUAZÚ',
    videoImage: images.filmImg10, // Use MP4 instead of PNG
    stillImage: images.filmImage11 // This is a PNG
  },
  {
    id: '5',
    title: 'Awasi Artist Immersion x Andrés Paredes',
    location: 'AWASI IGUAZÚ',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  },
  {
    id: '6',
    title: 'Awasi Artisti Immersion x Felipe Assadi & Catalina Zarhi - "Confluencia"',
    location: 'AWASI IGUAZÚ',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  },
  {
    id: '7',
    title: 'What does inclusion mean to you?',
    location: 'AWASI',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  },
  {
    id: '8',
    title: 'Doña Carmen',
    location: 'AWASI PATAGONIA',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  },
  {
    id: '9',
    title: 'The Sounds of the Atlantic Rainforest',
    location: 'AWASI IGUAZÚ',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  },
  {
    id: '10',
    title: 'A News Florence Dixie',
    location: 'AWASI PATAGONIA',
    videoImage: images.filmVideo1,
    stillImage: images.filmImg11
  }
];